module.exports = __webpack_public_path__ + "img/client-acb.a708ebc0.svg";